
'use client';

const services = [
  {
    icon: '01',
    title: 'Business Registration',
    short: 'Company Formation & Compliance',
    desc: 'Private limited, LLP, OPC, partnership firms — complete incorporation with MCA filings, PAN, TAN and GST registration.',
    tags: ['Pvt Ltd', 'LLP', 'OPC', 'GST'],
    img: '/images/home/ServicesGrid/Business_Registeration.png',
    href: '/services',
  },
  {
    icon: '02',
    title: 'Startup Funding',
    short: 'Investor Connect & Pitch Support',
    desc: 'From seed to Series A — we connect you with angel investors, VCs and government schemes like Startup India.',
    tags: ['Pitch Deck', 'Angel', 'VC', 'Grants'],
    img: '/images/home/ServicesGrid/Startup_Funding.png',
    href: '/services',
  },
  {
    icon: '03',
    title: 'Legal & Compliance',
    short: 'Contracts, IP & Regulatory Filing',
    desc: 'Trademark registration, contract drafting, FSSAI, MSME and annual ROC compliance — stay protected and penalty-free.',
    tags: ['Trademark', 'Contracts', 'FSSAI', 'ROC'],
    img: '/images/home/ServicesGrid/Legal%20Compliance.png',
    href: '/services',
  },
  {
    icon: '04',
    title: 'Accounting & Taxation',
    short: 'GST Filing, ITR & Bookkeeping',
    desc: 'Monthly bookkeeping, GST returns, income tax filing, payroll management and financial statement preparation.',
    tags: ['GST Filing', 'ITR', 'Payroll', 'Audit'],
    img: '/images/home/ServicesGrid/Accounting%20Taxation.png',
    href: '/services',
  },
  {
    icon: '05',
    title: 'Digital Marketing',
    short: 'SEO, Ads & Brand Strategy',
    desc: 'Data-driven campaigns across search, social and display. Build authority, generate leads and grow revenue.',
    tags: ['SEO', 'Google Ads', 'Meta', 'Branding'],
    img: '/images/home/ServicesGrid/Digital%20Marketing.png',
    href: '/services',
  },
  {
    icon: '06',
    title: 'IT Solutions',
    short: 'Web, App & Cloud Development',
    desc: 'Custom websites, mobile apps, ERP/CRM systems, cloud infrastructure and cybersecurity solutions built for scale.',
    tags: ['Web Dev', 'Mobile App', 'Cloud', 'ERP'],
    img: '/images/home/ServicesGrid/IT%20solutions.png',
    href: '/services',
  },
  // Added 2 new priority services below to complete the 8-item grid (4 columns x 2 rows)
  {
    icon: '07',
    title: 'ISO & Certification',
    short: 'Quality & Audit Readiness',
    desc: 'Achieve global standards with ISO 9001, 27001 and more. We handle documentation, audit readiness and compliance checks.',
    tags: ['ISO', 'Audit', 'Quality', 'Govt'],
    img: '/images/home/ServicesGrid/ISO_Certificate.png',
    href: '/services',
  },
  {
    icon: '08',
    title: 'HR & Staffing',
    short: 'Recruitment & Team Building',
    desc: 'End-to-end talent acquisition, policy drafting, corporate governance and employee training to build your dream team.',
    tags: ['Hiring', 'Training', 'Policies'],
    img: '/images/home/ServicesGrid/HR.png',
    href: '/services',
  },
];

export function ServicesGrid() {
  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="h-px w-8 bg-amber-500" />
              <span className="text-amber-600 text-xs font-semibold tracking-[0.18em] uppercase">What We Offer</span>
            </div>
            <h2
              className="text-3xl lg:text-4xl font-bold text-slate-900 leading-tight"
              style={{ fontFamily: "'Sora', sans-serif" }}
            >
              Comprehensive Business<br className="hidden lg:block" /> Solutions Under One Roof
            </h2>
          </div>
          <a
            href="/services"
            className="self-start lg:self-auto inline-flex items-center gap-2 text-sm font-semibold text-amber-600 border-b border-amber-300 pb-0.5 hover:border-amber-600 transition-colors duration-200"
          >
            View All Services
            <span>→</span>
          </a>
        </div>

        {/* Grid - 4 Columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((svc) => (
            <a
              key={svc.title}
              href={svc.href}
              className="group relative rounded-md overflow-hidden border border-slate-100 bg-white shadow-sm hover:shadow-xl duration-400 hover:-translate-y-1 flex flex-col"
            >
              {/* Image - HEIGHT UPDATED TO 300px */}
              <div className="relative h-[300px] overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 from-slate-900/60 to-transparent" />
                <div
                  className="absolute top-3 left-3 w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white"
                  style={{ background: 'linear-gradient(135deg, #d97706, #f59e0b)' }}
                >
                  {svc.icon}
                </div>
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                <div className="text-xs text-amber-600 font-semibold tracking-wide mb-1 uppercase">{svc.short}</div>
                <h3 className="text-slate-900 font-bold text-base mb-2" style={{ fontFamily: "'Sora', sans-serif" }}>
                  {svc.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed mb-4 flex-1">{svc.desc}</p>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5">
                  {svc.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 text-xs font-medium border border-amber-100"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Arrow */}
                <div className="flex items-center justify-end mt-4">
                  <span className="text-amber-500 text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                    Learn More <span>→</span>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
